import React from 'react'
import {Col, Container, Placeholder, Row} from 'react-bootstrap'

const PagePlaceholder = () => {
  return (
    <div className='p-4'>
      <Row>
        <Col md={4}>
          <Placeholder as='p' animation='wave' className='mb-4'>
            <Placeholder className='rounded-1 w-100 border-0' />
          </Placeholder>
        </Col>
        <Col md={8}>
          <Placeholder as='p' animation='wave' className='mb-4'>
            <Placeholder className='rounded-1 w-100 border-0' />
          </Placeholder>
        </Col>
      </Row>

      <Row>
        <Col md={8}>
          <Placeholder as='p' animation='wave' className='mb-4'>
            <Placeholder className='rounded-1 w-100 border-0' />
          </Placeholder>
        </Col>
        <Col md={4}>
          <Placeholder as='p' animation='wave' className='mb-4'>
            <Placeholder className='rounded-1 w-100 border-0' />
          </Placeholder>
        </Col>
      </Row>

      <Placeholder as='p' animation='wave' className='mb-4'>
        <Placeholder className='rounded-1 w-100 border-0' />
      </Placeholder>
    </div>
  )
}

export {PagePlaceholder}
